import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {httpService} from '../../../core/services/http.service';

export class ApiKeysCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/api-keys';

    async generateKey(): Promise<string> {
        return httpService
            .get(this.apiPath + '/key', {
                transformResponse: (data: any): any => data
            })
            .then((result: any): string => result.data);
    }

    async removeKey(key: string): Promise<any> {
        return httpService.delete(`/gt/gt-api/api-keys/${key}`);
    }
}
